import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.VehicleMake.Delete.IRequest;
type Response = Api.Core.VehicleMake.Delete.IResponse;
type Headers = Api.Core.VehicleMake.Delete.IHeaders;
const url = '/api/ProductManagement/VehicleMake/:id';
export default async function vehicleMakeDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
